<section fxFlex fxLayout="column">
	<header class="primary-color">
		<button class="close-button" mat-icon-button type="button" (keypress)="keyPressed($event)"
				(click)="cancel()">
			<mat-icon>clear</mat-icon>
		</button>
	</header>
	<mat-dialog-content class="confirmation-dialog-container">
		<h5>{{textContent | translate}}</h5>
	</mat-dialog-content>
	<mat-dialog-actions fxLayoutGap="10px">
		<button fxFlex mat-button (click)="cancel()" class="mat-secondary">{{cancelText | translate}}</button>
		<button fxFlex mat-raised-button color="primary" (click)="confirm()">{{confirmText | translate}}
		</button>
	</mat-dialog-actions>
</section>
